import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@metarouter-private/mr-mui';
import { PROCESS_STATUS } from 'app/shared/hooks/useProcessItems';

export default function BulkExportModalActions({ status, onClose }) {
  if (status === PROCESS_STATUS.PROCESSING) {
    return null;
  }
  return (
    <Button onClick={onClose} variant="outlined">
      Close
    </Button>
  );
}

BulkExportModalActions.propTypes = {
  status: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};
